export enum DatePreset {
  THIS_WEEK = "thisWeek",
  LAST_WEEK = "lastWeek",
  THIS_MONTH = "thisMonth",
  LAST_MONTH = "lastMonth",
  THIS_QUARTER = "thisQuarter",
  THIS_YEAR = "thisYear",
  LAST_YEAR = "lastYear"
}
